import { render, staticRenderFns } from "./sige.vue?vue&type=template&id=7fa1aa71&scoped=true&"
import script from "./sige.vue?vue&type=script&lang=js&"
export * from "./sige.vue?vue&type=script&lang=js&"
import style0 from "./sige.vue?vue&type=style&index=0&id=7fa1aa71&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1aa71",
  null
  
)

export default component.exports